import React from 'react';
import { Heading, Image } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';

const MotionImg = motion(Image);

const Modal = ({ image, setSelectedImg }) => {
  return (
    <AnimatePresence>
      {image && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            minWidth: '100vw',
            backgroundColor: 'rgba(0,0,0,0.9)',
            minHeight: '100vh',
            zIndex: 11,
            display: 'grid',
            placeItems: 'center',
          }}
          onClick={() => setSelectedImg(null)}
        >
          <MotionImg
            height="500px"
            objectFit="contain"
            borderRadius="2xl"
            src={image}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
